export function setEmailCookie(email) {
    const url = '/api/sitecore/TrackingCookie/SetEmailCookie';
    const options = {
      method: 'POST',
      body: JSON.stringify({
        Email: email.trim(),
      }),
      headers: new Headers({
        'Content-Type': 'application/json',
      }),
    };
    try {
        fetch(url, options).catch((err) => {
            console.log(err);
        });
    } catch (error) {
        console.log(error);
    }
}
